import { Tabs, notification } from "antd";
import Card from "components/Card/Card";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { greyColor } from "assets/jss/material-dashboard-pro-react";
import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import HTMLEditor from "components/HTMLEditor/HTMLEditor";
import BackgroundInformation from "./backgroundInformation/BackgroundInformation";
import Criterion1 from "./criterion1/Criterion1";
import Criterion2 from "./criterion2/Criterion2";
import Criterion3 from "./criterion3/Criterion3";
import Criterion4 from "./criterion4/Criterion4";
import Criterion5 from "./criterion5/Criterion5";
import Criterion6 from "./criterion6/Criterion6";
import Criterion7 from "./criterion7/Criterion7";
import Criterion8 from "./criterion8/Criterion8";
import ProgramCriteria from "./programCriteria/ProgramCriteria";
import AppendixA from "./appendices/appendixA/AppendixA";
import AppendixB from "./appendices/appendixB/AppendixB";
import AppendixC from "./appendices/appendixC/AppendixC";
import AppendixD from "./appendices/appendixD/AppendixD";
import Stepper from "../Stepper";
import SSRSTRUCTURE from "./SSRStructure";
import DescriptionIcon from "@mui/icons-material/Description";
import Button from "components/CustomButtons/Button";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import ReportDocumentsSection from "./reportDocument/ReportDocumentsSection";
import { fetchProgramById } from "../../../../reduxToolkit/features/program/ProgramsSlice";
import {
  fetchReport,
  updateReport,
} from "../../../../reduxToolkit/features/AnnualProgramReport/AnnualProgramReportSlice";
import { useSelector, useDispatch } from "react-redux";
import { calculateYearsBetweenExperienceDates } from "assets/utils/helperFunction";
import FloatingEditButton from "./FloatingEditReportButton";
import ErrorModal from "../../../Components/ErrorModal";

const onChange = (key) => {
  console.log(key);
};

const Report = ({
  report,
  program,
  setReportBody,
  derivedBackgroundInformation,
  derivedCriterion1,
  derivedCriterion2,
  derivedCriterion3,
  derivedCriterion4,
  derivedCriterion5,
  derivedCriterion6,
  derivedCriterion7,
  derivedCriterion8,
}) => {
  return (
    <>
      <p
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#5B5B5B",
        }}
      >
        ABET SELF-STUDY REPORT
      </p>
      <p
        style={{
          fontSize: "14px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#5B5B5B",
        }}
      >
        for the
      </p>
      <p
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#5B5B5B",
        }}
      >
        {report?.programName} Program
      </p>
      <p
        style={{
          fontSize: "14px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#5B5B5B",
        }}
      >
        at
      </p>
      <p
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#5B5B5B",
        }}
      >
        {report?.institutionName} University
      </p>
      <p
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#5B5B5B",
        }}
      >
        {report?.location}
      </p>
      <p
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          textAlign: "center",
          paddingBottom: 10,
          borderBottom: `1px solid ${greyColor[0]}`,
          color: "#5B5B5B",
        }}
      >
        {report?.date}
      </p>

      <Tabs
        defaultActiveKey="1"
        onChange={onChange}
        items={[
          {
            label: `BACKGROUND INFORMATION`,
            key: "1",
            children: derivedBackgroundInformation && (
              <BackgroundInformation
                report={report}
                data={derivedBackgroundInformation}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `STUDENTS`,
            label: `CRITERION 1`,
            key: "2",
            children: derivedCriterion1 && (
              <Criterion1
                report={report}
                data={derivedCriterion1}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `PROGRAM EDUCATIONAL OBJECTIVES`,
            label: `CRITERION 2`,
            key: "3",
            children: derivedCriterion2 && (
              <Criterion2
                report={report}
                data={derivedCriterion2}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `STUDENT OUTCOMES`,
            label: `CRITERION 3`,
            key: "4",
            children: derivedCriterion3 && (
              <Criterion3
                report={report}
                data={derivedCriterion3}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `CONTINUOUS IMPROVEMENT`,
            label: `CRITERION 4`,
            key: "5",
            children: derivedCriterion4 && (
              <Criterion4
                report={report}
                data={derivedCriterion4}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `CURRICULUM`,
            label: `CRITERION 5`,
            key: "6",
            children: derivedCriterion5 && (
              <Criterion5
                report={report}
                data={derivedCriterion5}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `FACULTY`,
            label: `CRITERION 6`,
            key: "7",
            children: derivedCriterion6 && (
              <Criterion6
                report={report}
                data={derivedCriterion6}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `FACILITIES`,
            label: `CRITERION 7`,
            key: "8",
            children: derivedCriterion7 && (
              <Criterion7
                report={report}
                data={derivedCriterion7}
                setReportBody={setReportBody}
              />
            ),
          },
          {
            // label: `INSTITUTIONAL SUPPORT`,
            label: `CRITERION 8`,
            key: "9",
            children: derivedCriterion8 && (
              <Criterion8
                report={report}
                data={derivedCriterion8}
                setReportBody={setReportBody}
              />
            ),
          },
          // {
          //   label: `PROGRAM CRITERIA`,
          //   key: "10",
          //   children: <ProgramCriteria />,
          // },
          {
            label: `Appendix A`,
            key: "11",
            children: <AppendixA data={SSRSTRUCTURE.AppendixA_CourseSyllabi} />,
          },
          {
            label: `Appendix B`,
            key: "12",
            children: <AppendixB data={SSRSTRUCTURE.AppendixB_FacultyVitae} />,
          },
          {
            label: `Appendix C`,
            key: "13",
            children: <AppendixC data={SSRSTRUCTURE.AppendixC_Equipment} />,
          },
          {
            label: `Appendix D`,
            key: "14",
            children: (
              <AppendixD data={SSRSTRUCTURE.AppendixD_InstitutionalSummary} />
            ),
          },
        ]}
      />
    </>
  );
};

const SSR = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const possibleStates = SSRSTRUCTURE.possibleStates;
  const [stateName, setStateName] = useState("Created");
  const [reportBody, setReportBody] = useState();
  const [expandDocumentsSection, setExpandDocumentsSection] = useState(false);
  const [derivedBackgroundInformation, setDerivedBackgroundInformation] =
    useState();
  const [derivedCriterion1, setDerivedCriterion1] = useState();
  const [derivedCriterion2, setDerivedCriterion2] = useState();
  const [derivedCriterion3, setDerivedCriterion3] = useState();
  const [derivedCriterion4, setDerivedCriterion4] = useState();
  const [derivedCriterion5, setDerivedCriterion5] = useState();
  const [derivedCriterion6, setDerivedCriterion6] = useState();
  const [derivedCriterion7, setDerivedCriterion7] = useState();
  const [derivedCriterion8, setDerivedCriterion8] = useState();

  const { currentUser } = useSelector((state) => state.user);

  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const containerStyle = {
    height: "calc(100vh - 150px)",
  };
  const rotatedIconStyle = {
    transform: "rotate(180deg)",
  };
  const transitionStyle = {
    transition: "all 0.3s ease-in-out",
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };
  // const deriveBackgroundInformation = (program) => {
  //   // Implement logic to derive background information from program and populate SSRSTRUCTURE.BACKGROUNDINFORMATION
  //   const backgroudInformation = {
  //     ContactInformation: {
  //       name: `${program.person_detail?.[0]?.first_name} ${program.person_detail?.[0]?.last_name}`,
  //       department: program.department_detail?.[0]?.name,
  //       college: program.college_detail?.[0]?.name,
  //       university: program.university_detail?.[0]?.name,
  //       //-----------------------------------------------------//
  //       address: program.coordinators_detail?.[0]?.work_location ?? "",
  //       phone: program.coordinators_detail?.[0]?.work_phone ?? "",
  //       email: program.coordinators_detail?.[0]?.work_email ?? "",
  //       fax: program.coordinators_detail?.[0]?.work_phone ?? "",
  //     },
  //     // major changes are the actions (with "high priority", and whose states are "done") taken to adress feedback of last general review
  //     ProgramHistory: {
  //       //-----------------------------------------------------//
  //       lastReviewDate: program.last_activity ?? "October 5-7, 2019",
  //       //-----------------------------------------------------//
  //       majorChanges: [],
  //       history: program.history,
  //       description: `
  //         <p>The last general review was held October 5-7, 2015. Significant changes to the program since the last visit include the hiring of eight new full-time engineering faculty members. No significant changes have been made to the curriculum. Changes in response to a shortcoming identified in the previous visit are described in Section G below.</p><br></br>
  //         `,
  //     },
  //     Options: {
  //       //options==specializations?
  //       //-----------------------------------------------------//
  //       options: program.specialization_details?.length
  //         ? program.specialization_details?.map((spec) => spec.name)
  //         : [],
  //       tracks: program.major_tracks_details?.length
  //         ? program.specialization_details?.map((track) => track.pathway)
  //         : [],
  //       description: `<p>The degree conferred is the B.S. in Engineering with options in one of four areas: civil, chemical, electrical, and mechanical. The option is noted on the student transcript, but is not indicated on the line designating the degree conferred. Options are not required.</p>`,
  //     },
  //     ProgramDeliveryModes: {
  //       //-----------------------------------------------------//
  //       modes: program.deliveryModes ?? [],
  //       description: `<p>The Engineering program is offered in the day mode with courses offered in traditional lecture/laboratory style. Occasionally a course is offered in the evening. There is no significant distance education or web-based component in the program. All students are encouraged to spend a minimum of one semester in a cooperative education or internship position.</p>`,
  //     },
  //     ProgramLocations: {
  //       locations: program.accredited_campus_location?.length
  //         ? program.accredited_campus_location.map((loc) => loc.location)
  //         : [],
  //       description: `<p>All elements of the program are offered on the Upper State University campus. No portion of the program is offered elsewhere.</p>`,
  //     },
  //     PublicDisclosure: {
  //       //-----------------------------------------------------//
  //       publicDisclosure: program.publicDisclosure ?? "university website",
  //       description: `<p>Program Educational Objectives, Student Outcomes, and student enrollment and graduation data are available on the Upper State Public Website at www.upperstate.edu/abet.</p>`,
  //     },
  //   };
  //   return backgroudInformation;
  // };

  // const deriveCriterion1 = (program) => {
  //   // Implement logic to derive Criterion1 from program and populate SSRSTRUCTURE.CRITERION1_STUDENTS
  //   const CRITERION1_STUDENTS = {
  //     StudentAdmissions: {
  //       // Progeram admission requirements
  //       studentAdmissionRequirements: program.admissions_detail?.length
  //         ? program.admissions_detail?.map((req) => req.title)
  //         : [],
  //       description: `<p>All Upper-State University (USU) first-year engineering students are admitted and dually enrolled in the Undergraduate University Division (UUD) and the College of Natural Science and Engineering (CNSE). </p><br></br>
  //             <p>Exceptions to the above standards may be made on an individual basis and are reviewed by the Admissions Office. Those who are admitted on an exception basis may be required to take supplementary work during their first year at Upper State U.niversity. Credits in supplementary courses are not applied to graduation requirements.</p>
  //             `,
  //     },
  //     EvaluatingStudentPerformance: {
  //       // All Courses prerequisites
  //       // prerequisites: [
  //       //   {
  //       //     key: "1",
  //       //     title: "Finance1",
  //       //     children: [
  //       //       {
  //       //         key: "11",
  //       //         title:
  //       //           "Students must have more than a 2.00 cumulative grade point average.",
  //       //       },
  //       //       {
  //       //         key: "12",
  //       //         title:
  //       //           "Students must not earn a 1.0 in one term, with six or more credits.",
  //       //       },
  //       //     ],
  //       //   },
  //       //   {
  //       //     key: "2",
  //       //     title: "Finance2",
  //       //     children: [
  //       //       {
  //       //         key: "21",
  //       //         title:
  //       //           "Students must have more than a 1.00 cumulative grade point average. ",
  //       //       },
  //       //       {
  //       //         key: "22",
  //       //         title:
  //       //           "Students must not earn a 1.5 in one term, with five or more credits.",
  //       //       },
  //       //     ],
  //       //   },
  //       // ],
  //       prerequisites: program.courses?.length
  //         ? program.courses?.map((course) => ({
  //             key: course.id,
  //             title: course.title,
  //             children: course.prerequisites_ids?.length
  //               ? course.prerequisites_ids?.map((req) => ({
  //                   key: req.id,
  //                   title: req.requisite,
  //                 }))
  //               : [],
  //           }))
  //         : [],

  //       description: `<p>Two files are maintained for each upper-level student, one in the associate dean’s office and one in the advisor’s office. These electronic files contain all grade sheets, transfer credit evaluations, course schedule planning sheets, records of advisor conferences, etc. </p><br></br>
  //             <p><strong>Databases:</strong> Advisors and students are able to assess student progress toward the degree using a web-based Degree Auditing System (DAS). DAS is also able to produce an unofficial transcript or technical grade point average calculation report for students. For advisors, support staff, and administrators, DAS allows queries of student data using a variety of parameters and data reporting and sorting choices. DAS obtains its data from the university’s mainframe- based Student Information Report System (SIRS), which houses all course- and student-related data for all USU students and courses (up to 30 years back). All academic advisors, authorized staff, and administrators have access to all SIRS information.</p><br></br>
  //             <p>The course registration system interfaces with SIRS and DAS to ensure that prerequisites are met. A student is not permitted to register for a course unless all prerequisites identified in SIRS are met or the instructor teaching the course approves an override of the system.</p><br></br>
  //             <p>Academic advisors work closely with faculty and the Office of Student Placement to connect students to co-curricular opportunities such as cooperative education, internships, and study abroad. These students often have special scheduling considerations, and academic advisors help students devise a plan to complete degree requirements in a timely manner.</p>`,
  //     },
  //     TransferStudentsAndTransferCourses: {
  //       //-----------------------------------------------------//
  //       transferStudentsAcceptanceRequirements: program.acceptance_requirements
  //         ?.length
  //         ? program.acceptance_requirements?.map((req) => req.name)
  //         : [],
  //       //-----------------------------------------------------//
  //       transferCreditAcceptanceRequirements: program.transfer_credits?.length
  //         ? program.transfer_credits?.map((req) => req.name)
  //         : [],
  //       description: `<p>There are no formal articulation agreements with other institutions, with the exception of the Minority Advancement Program participants at Upper State Community College. Qualified students (10 per year maximum) continuing to meet the established requirements of this program are granted admission and scholarships to USU.</p>`,
  //     },
  //     AdvisingAndCareerGuidance: {
  //       // frequency: { times: 2, term: "year" },
  //       // // advisor can be program faculty, departmental, college or university advisor
  //       // advivisors: "program faculty",
  //       //-----------------------------------------------------//
  //       GuidanceAndOrientationProgramsForNewStudents:
  //         program.guidance_for_new_students,
  //       //-----------------------------------------------------//
  //       StudentCounselingServices: program.student_counseling,
  //       //-----------------------------------------------------//
  //       SpecialSupport: program.special_support,
  //       description: `<p>Student advising is conducted through the Office of the Associate Dean for Undergraduate Studies in the CNSE. In addition to its importance in career counseling, advising helps ensure that B.S. graduates have completed the curriculum of the engineering program. The core engineering curriculum and the electives are the key elements in meeting program educational objectives since U all   of the educational objectives are addressed and student outcomes are achieved through the curriculum. Specifically, the curriculum provides a thorough base of mathematics, physical science, computing foundations, laboratory experience, and applications experience which prepares students to apply engineering problem-solving principles to a variety of contemporary problems. In addition, the curriculum provides the general education necessary to identify the effect of design and implementation decisions in the broader societal context. The rigorous curriculum is the foundation to the graduate’s ability to function as a practicing professional or graduate student.</p><br></br>
  //           <p>The CNSE employs a professional full-time academic advisor for the engineering program. The advisor has a master’s degree and is a member of a professional advising association. Engineering advising is done separately from the other CNSE students, but the engineering advisor works closely with the 10 academic advisors for the other CNSE students. The CNSE Advising Coordinator and other CNSE advisors also assist with routine advising when needed. </p><br></br>
  //           <p>All students first meet their advisor at the required First-year Orientation Program before starting classes. Further advising is available upon request, but not mandatory, and students are ultimately responsible for planning their academic programs and meeting degree requirements.</p>
  //           `,
  //     },
  //     //-----------------------------------------------------//
  //     WorkInLieuOfCourses: {
  //       // work in lien of courses could include life experience, Advanced Placement, dual enrollment, test out, military experience
  //       // workExperience: [
  //       //   "life experience",
  //       //   "advanced Placement",
  //       //   "dual enrollment",
  //       //   "test out",
  //       //   "military experience",
  //       // ],
  //       // workExperienceCreditAwardingRequirements: [],
  //       WorkInLieuOfCourses: program.workInLieuOfCourses ?? "",
  //       description: `<p>Upper State University Engineering students are encouraged to spend a minimum of one semester in one of the listed-above "work in lieu of courses" . The work experience is listed on the student transcript, but no credit or grade is assigned.</p>`,
  //     },
  //     GraduationRequirements: {
  //       programName: program.program_degree_name,
  //       awardedDegreeName: program.degree_awarded,
  //       graduationRequirements: program.graduations_detail?.length
  //         ? program.graduations_detail?.map((req) => req.title)
  //         : [],
  //       description: `<p>A senior audit is conducted in the semester after a CNSE student attains 100 credits. At that time, the student’s record is reviewed for progress toward the B.S. in Engineering degree, any transfer credits that still need to be evaluated, documentation of waivers (substitutions), and completion of electives. Students are not required to meet with the advisors, but are strongly encouraged by e-mail and phone messages, when necessary. When a student applies for graduation, the student record is reviewed by staff at several layers. The record is finally submitted for certification by the Associate Dean. Any degree deficiencies are reported to the Registrar’s Office.</p>`,
  //     },
  //     RecordsOfStudentWorkOrTranscripts: {
  //       //-----------------------------------------------------//
  //       transcriptsFiles: [],
  //       attachments: [],
  //       description: `<p>Transcripts from three May 2020 graduates are submitted along with this self-study report. Additional information concerning transfer credit evaluation is attached to the transcript. The degree, degree status, major, and minor are specified in the transcript header on the first page</p>`,
  //     },
  //   };
  //   return CRITERION1_STUDENTS;
  // };

  // const deriveCriterion2 = (program) => {
  //   const CRITERION2_PROGRAMEDUCATIONALOBJECTIVES = {
  //     MissionStatement: {
  //       institutionMissionStatement: program?.university_detail?.[0].mission,
  //       collegeMissionStatement: program?.college_detail?.[0].mission,
  //       programMissionStatement: program?.mission,
  //     },
  //     ProgramEducationalObjectives: {
  //       //-----------------------------------------------------//
  //       PEOs: program.peos_details?.length
  //         ? program.peos_details.map((peo) => `${peo.code}:  ${peo.name}`)
  //         : [],
  //       // [
  //       //   "be effective in the design of engineering solutions and the practical application of engineering principles",
  //       //   "effectively lead, work, and communicate in cross-functional teams",
  //       //   "conduct themselves with high standards of ethics",
  //       //   "be successfully employed in an engineering or related field, or accepted into graduate programs",
  //       //   "expand their knowledge and capabilities through continuing education or other lifelong learning experiences",
  //       //   "serve their communities, whether locally, nationally, or globally.",
  //       // ]
  //       publicDisclosure: program?.publicDisclosure ?? "university website",
  //       programName: program?.program_degree_name,
  //       description: `<p>The program educational objectives (PEOs) support the missions of the institution and of the college. The program educational objectives are published in our on-line undergraduate catalog (Hwww.upperstate.edu/ugcatalogH), in college brochures, in recruiting literature, and are posted in our building in various display cases. </p>`,
  //     },
  //     ConsistencyOfTheProgramEducationalObjectivesWithTheMissionOfTheInstitution:
  //       {
  //         description: `<p>If the program educational objectives are achieved then the program will have produced graduates who are successful professionals and also good citizens.  That is, the program will provide a quality education based on expert knowledge that enables its graduates to be successful problem solvers in a global society</p>`,
  //       },
  //     ProgramConstituencies: {
  //       //-----------------------------------------------------//
  //       description: `<p>Each of these constituencies is a stakeholder in the educational processes in the engineering program. The Engineering faculty has the academic responsibility for the curriculum and for education of the students. The program and curricula they administer is a major means of accomplishing all the program’s objectives. The engineering students are included as a program constituency because their input is valuable feedback for program improvement, many have had industrial experience, and they are the direct beneficiaries of an effective educational process. Alumni are the “products” and strong supporters of the academic program. Their careers demonstrate the accomplishment of the PEOs. Alumni often become the major donors who play advisory roles and provide financial support for scholarships and endowments that directly affect students in their education. Employers desire to hire well-educated undergraduate engineering students, and graduates who accomplish all the PEOs are a clear benefit to their employers. In summary, each of these constituencies has a vested interest in the success and continued improvement of the engineering program at Upper State University and the proper direction of the program through its educational objectives.</p>`,
  //       programName: program?.program_degree_name,
  //     },
  //     ProcessForReviewOfTheProgramEducationalObjectives: {
  //       description: `<p>The overall process to determine and approve the current version of the program educational objectives (PEOs) began in the summer of 2018. Since our Engineering Advisory Council includes representation of several constituencies (alumni, employers, major donors) a meeting of the board was held to elicit a list of constituent needs. Based on this list, a first draft of the PEOs was presented in early fall by the Engineering Curriculum Committee—a representative body of faculty, advisors, and students. All Engineering faculty members were invited to edit the proposed PEOs; about 50 percent of the faculty responded, which is a good response level for the survey approach used in this exercise. The second draft was presented to the Engineering Advisory Council for additional comments. While on campus for the fall semester Career Fair (November 2018), ten representatives of major employers participated in a lunchtime focus group during which the PEOs were evaluated and discussed. Copies of the PEOs were distributed to the employer representatives about two weeks in advance of the focus group meeting. Given the input from all of these sources, the final version of the PEOs was approved by a unanimous vote of the engineering faculty in April 2019.</p><p><br></p><p>Since the initial development of our PEOs, they have been reevaluated each time the alumni survey is administered, during the annual Engineering Advisory Council meetings, in the last Engineering Curriculum Committee meeting of the academic year, as part of the senior exit interview, and biannually in employer focus groups. Whether the evaluation of PEOs suggests a need for their revision or not, the table below summarizes the scheduling of constituent input to PEOs.</p><p><br></p><table><tbody><tr><td style="width: 171px;"><p data-cellwidth="171px"><strong>Input Method</strong></p></td><td style="width: 171px;"><p data-cellwidth="171px"><strong>Schedule</strong></p></td><td style="width: 171px;"><p data-cellwidth="171px"><strong>Constituent</strong></p></td></tr><tr><td style="width: 171px;"><p data-cellwidth="171px">Alumni survey</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Every three years</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Alumni 2-5 years out</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 171px;"><p data-cellwidth="171px">Employer focus group</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Every two years during Career Fair</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Employers (and recruiters); some are alumni</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 171px;"><p data-cellwidth="171px">Senior exit interview</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Annually</p><p data-cellwidth="171px"><br></p></td><td style="width: 171px;"><p data-cellwidth="171px">Students; retrospective discussion of PEOs and their intended career paths</p><p data-cellwidth="171px"><br></p></td></tr></tbody></table><p><br></p><p><br></p><p>The program’s ABET coordinator maintains a documentation of the review of PEOs as part of the continuous improvement process in a web-based database. The documentation includes minutes from Advisory Council and curriculum committee meetings, survey summaries, and notes from focus groups. A summary of the PEO review is also included in the assessment report. The coordinator, the chairperson, and the chair of the Curriculum Committee each have direct access to these files.</p><p>Since the last accreditation review in 2015, the changes in the table below have been proposed, discussed, and approved:</p><p><br></p><p><br></p><table><tbody><tr><td style="width: 133px;"><p data-cellwidth="133px"><strong>Modification</strong></p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px"><strong>Proposing Constituency</strong></p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px"><strong>Approval Date</strong></p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 133px;"><p data-cellwidth="133px">Expand first PEO to include practical application of engineering principles; add PEO on leadership and ability to function in cross-functional teams</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Alumni; strongly supported by the Advisory Council</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Spring, 2017</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style="width: 133px;"><p data-cellwidth="133px">Add “global” to the list of communities in which our graduates will serve</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Employers</p><p data-cellwidth="171px"><br></p></td><td style="width: 133px;"><p data-cellwidth="133px">Spring, 2019</p><p data-cellwidth="171px"><br></p></td></tr><tr><td style=""><p>Various grammatical and stylistic modifications</p><p><br></p></td><td style=""><p>Curriculum Committee</p><p data-cellwidth="133px"><br></p></td><td style=""><p>Various</p><p data-cellwidth="133px"><br></p></td></tr></tbody></table><p><br></p><p><br></p>`,
  //       // add recent changes to PEOs
  //     },
  //   };
  //   return CRITERION2_PROGRAMEDUCATIONALOBJECTIVES;
  // };

  // const deriveCriterion3 = (program) => {
  //   const CRITERION3_STUDENTOUTCOMES = {
  //     StudentOutcomes: {
  //       //-----------------------------------------------------//
  //       PLOs: program?.plos_details?.length
  //         ? program.plos_details.map((plo) => `${plo.code}:  ${plo.name}`)
  //         : [],
  //       // [
  //       //   "an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
  //       //   "an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, welfare, as well as global, cultural, social, environmental, and economic factors ",
  //       //   "an ability to communicate effectively with a range of audiences",
  //       //   "an ability to function effectively on a team whose members together provide leadership, create a collaborative and inclusive environment, establish goals, plan tasks, and meet objectives",
  //       //   "an ability to develop and conduct appropriate experimentation, analyze and interpret data, and use engineering judgment to draw conclusions",
  //       //   "an ability to recognize ethical and professional responsibilities in engineering situations and make informed judgments, which must consider the impact of engineering solutions in global, economic, environmental, and societal contexts",
  //       //   "an ability to acquire and apply new knowledge as needed, using appropriate learning strategies",
  //       //   "a willingness to assume leadership roles and responsibilities",
  //       // ],
  //       // each PLO should have an array of appropriate General Criteria Student Outcomes, if the  PLO does not address any General Criteria, the list should be empty
  //       programName: program?.program_degree_name,
  //       publicDisclosure: program?.publicDisclosure ?? "university website",
  //       description: `<p>The student outcomes are publicly available on our web site (www.upperstate.edu/abet) and published in our on-line undergraduate catalog (www.upperstate.edu/catalog), in college brochures, in recruiting literature, and are posted in our building in various display cases.</p>
  //       <br></br> <p>The eight student outcomes for the Engineering program at Upper State University are listed below. They encompass all the ABET EAC Criterion 3 outcomes. The ABET EAC Criterion 3 (EAC C3) student outcomes are noted parenthetically below each USU student outcome.  We have added an outcome related directly to leadership. We have also adopted the Engineering Criteria definition of outcomes as narrower statements that describe what students are expected to know or be able to do by the time of graduation from our program.</p>`,
  //     },
  //     RelationshipOfStudentOutcomesToProgramEducationalObjectives: {
  //       //a list of the PEOs codes
  //       //-----------------------------------------------------//
  //       PEOs: program.peos_details?.length
  //         ? program.peos_details.map((peo) => peo.code)
  //         : [],
  //       //the mapping array should follow the following format:
  //       PLOs_PEOs_mapping: program.peosplos_mapping_details?.length
  //         ? program.peosplos_mapping_details.map((plo) => {
  //             let res = {};
  //             let obj = {};
  //             for (let peo of program.peos_details) {
  //               plo.weight_plos?.map((p) => p.peo_id)?.includes(peo.id)
  //                 ? (obj[peo.code] = true)
  //                 : (obj[peo.code] = false);
  //             }
  //             res = { PLO: plo.name, ...obj };
  //             return res;
  //           })
  //         : [],
  //       // PLOs_PEOs_mapping: [
  //       //   {
  //       //     PLO: "1. an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
  //       //     PEO1: true,
  //       //     PEO2: false,
  //       //     PEO3: false,
  //       //   },
  //       //   {
  //       //     PLO: "2. an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, welfare, as well as global, cultural, social, environmental, and economic factors",
  //       //     PEO1: false,
  //       //     PEO2: false,
  //       //     PEO3: false,
  //       //   },
  //       //   {
  //       //     PLO: "3. an ability to communicate effectively with a range of audiences",
  //       //     PEO1: true,
  //       //     PEO2: true,
  //       //     PEO3: false,
  //       //   },
  //       //   {
  //       //     PLO: "4. an ability to function effectively on a team whose members together provide leadership, create a collaborative and inclusive environment, establish goals, plan tasks, and meet objectives",
  //       //     PEO1: true,
  //       //     PEO2: false,
  //       //     PEO3: false,
  //       //   },
  //       //   {
  //       //     PLO: "5. an ability to develop and conduct appropriate experimentation, analyze and interpret data, and use engineering judgment to draw conclusions",
  //       //     PEO1: true,
  //       //     PEO2: false,
  //       //     PEO3: false,
  //       //   },
  //       //   {
  //       //     PLO: "6. an ability to recognize ethical and professional responsibilities in engineering situations and make informed judgments, which must consider the impact of engineering solutions in global, economic, environmental, and societal contexts",
  //       //     PEO1: false,
  //       //     PEO2: true,
  //       //     PEO3: false,
  //       //   },
  //       //   {
  //       //     PLO: "7. an ability to acquire and apply new knowledge as needed, using appropriate learning strategies",
  //       //     PEO1: true,
  //       //     PEO2: true,
  //       //     PEO3: true,
  //       //   },
  //       //   {
  //       //     PLO: "8. a willingness to assume leadership roles and responsibilities",
  //       //     PEO1: true,
  //       //     PEO2: false,
  //       //     PEO3: false,
  //       //   },
  //       // ],
  //       PLOs_Indicators_mapping: program.peosplos_mapping_details?.length
  //         ? program.peosplos_mapping_details.map((plo) => {
  //             const indicators = plo.plo_indicators?.map((ind) => ind.name);
  //             return { PLO: plo.name, indicators };
  //           })
  //         : [],
  //       // PLOs_Indicators_mapping: [
  //       //   {
  //       //     PLO: "1. an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
  //       //     indicators: [
  //       //       "Problem statement shows understanding of the problem",
  //       //       "Problem solution is appropriate and within reasonable constraints ",
  //       //       "Applies mathematical and/or science principles to achieve analytical or numerical solution to model equations",
  //       //       "Selects appropriate techniques and tools for a specific engineering task",
  //       //       "Compares results with results from alternative tools or techniques",
  //       //     ],
  //       //   },
  //       //   {
  //       //     PLO: "2. an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, welfare, as well as global, cultural, social, environmental, and economic factors",
  //       //     indicators: [
  //       //       "Produces a clear and unambiguous needs statement in a design project",
  //       //       "Identifies constraints on the design problem, and establishes criteria for acceptability and desirability of solutions",
  //       //       "Evaluates and analyzes the economics of an engineering problem solution",
  //       //       "Uses risk analysis techniques to characterize and respond to risks in product or process design",
  //       //     ],
  //       //   },
  //       //   {
  //       //     PLO: "3. an ability to communicate effectively with a range of audiences",
  //       //     indicators: [
  //       //       "Writing conforms to appropriate technical style format appropriate to the audience",
  //       //       "Graphics used to enhance presentation",
  //       //     ],
  //       //   },
  //       //   {
  //       //     PLO: "4. an ability to function effectively on a team whose members together provide leadership, create a collaborative and inclusive environment, establish goals, plan tasks, and meet objectives",
  //       //     indicators: [
  //       //       "Fulfills appropriate roles to ensure team success",
  //       //       "Integrates input from all team members and makes decisions in relation to objective criteria",
  //       //       "Facilitates communication among teammates, asks for feedback and uses suggestions",
  //       //     ],
  //       //   },
  //       //   {
  //       //     PLO: "5. an ability to develop and conduct appropriate experimentation, analyze and interpret data, and use engineering judgment to draw conclusions",
  //       //     indicators: [
  //       //       "Observes good lab practice and operates instrumentation with ease",
  //       //       "Determines data that are appropriate to collect and selects appropriate equipment, protocols, etc. for measuring the appropriate variables to get required data",
  //       //       "Uses appropriate tools to analyze data and verifies and validates experimental results including the use of statistics to account for experimental error",
  //       //     ],
  //       //   },
  //       //   {
  //       //     PLO: "6. an ability to recognize ethical and professional responsibilities in engineering situations and make informed judgments, which must consider the impact of engineering solutions in global, economic, environmental, and societal contexts",
  //       //     indicators: [
  //       //       "Knows code of ethics for the discipline",
  //       //       "Evaluates conflicting/competing social values to make informed decisions about an engineering solution",
  //       //       "Identifies the environmental and social issues involved in an engineering solution and incorporates that sensitivity into the design process",
  //       //     ],
  //       //   },
  //       //   {
  //       //     PLO: "7. an ability to acquire and apply new knowledge as needed, using appropriate learning strategies",
  //       //     indicators: [
  //       //       "Expresses an awareness that education is continuous after graduation",
  //       //       "Able to find information relevant to problem solution without guidance",
  //       //     ],
  //       //   },
  //       //   {
  //       //     PLO: "8. a willingness to assume leadership roles and responsibilities",
  //       //     indicators: [
  //       //       "Expresses a willingness to take on leadership responsibility",
  //       //       "Demonstrates the ability to monitor team progress and make suggestions when needed",
  //       //       "Engages team members in problem solution",
  //       //     ],
  //       //   },
  //       // ],
  //       description: "",
  //     },
  //   };
  //   return CRITERION3_STUDENTOUTCOMES;
  // };

  // const deriveCriterion4 = (program) => {
  //   const CRITERION4_CONTINUOUSIMPROVEMENT = {
  //     StudentOutcomes: {
  //       // if assessment processes are the assessment methods
  //       assessmentMethods: [
  //         { assessmentMethod: "oral-exam", description: "" },
  //         { assessmentMethod: "focus-group", description: "" },
  //       ],
  //       assessmentFrequency: "",
  //       // should I include Data collection cycle and Cycle of activity for each student outcome tables?
  //       //the mapping array should follow the following format:
  //       // PLOs_courses_mapping: program.peosplos_mapping_details?.length
  //       //   ? program.peosplos_mapping_details.map((plo) => {
  //       //       let res = {};
  //       //       let obj = {};
  //       //       let supportedCourses = [];

  //       //       // Collect all supported courses for this PLO
  //       //       for (let ind of plo.plo_indicators) {
  //       //         let arr =
  //       //           ind.weight_clos?.map((clo) => clo.clo?.course.id) || [];
  //       //         supportedCourses.push(...arr);
  //       //       }
  //       //       console.log("supportedCourses", supportedCourses);

  //       //       // Remove duplicates
  //       //       let noDubSupportedCourses = [...new Set(supportedCourses)];
  //       //       console.log("noDubSupportedCourses", noDubSupportedCourses);

  //       //       // Now check each course against the complete list of supported courses
  //       //       for (let course of program.courses) {
  //       //         obj[course.code] = noDubSupportedCourses.includes(course.id);
  //       //       }

  //       //       res = { PLO: plo.name, ...obj };
  //       //       // console.log("resssssssss", res);
  //       //       return res;
  //       //     })
  //       //   : [],
  //       PLOs_courses_mapping: program.peosplos_mapping_details?.length
  //         ? program.peosplos_mapping_details.map((plo) => {
  //             let supportedCourses = new Set();

  //             // Collect all supported courses for this PLO
  //             for (let ind of plo.plo_indicators) {
  //               ind.weight_clos.forEach((clo) => {
  //                 if (clo.clo?.course?.id) {
  //                   supportedCourses.add(clo.clo.course.id);
  //                 }
  //               });
  //             }

  //             console.log("supportedCourses", supportedCourses);

  //             // Create the mapping object
  //             let courseMapping = {};
  //             for (let course of program.courses) {
  //               courseMapping[course.code] = supportedCourses.has(course.id);
  //             }
  //             console.log("courseMapping", courseMapping);
  //             return { PLO: plo.name, ...courseMapping };
  //           })
  //         : [],
  //       // [
  //       //   {
  //       //     id: "3.1",
  //       //     PLO: "3.1 Complex Eng. problem",
  //       //     EGR1010: true,
  //       //     EGR1015: "Oral & written",
  //       //     EGR1011: false,
  //       //   },
  //       //   {
  //       //     id: "3.2",
  //       //     PLO: "3.2 Eng. Design",
  //       //     1010: "Oral",
  //       //     1015: true,
  //       //     1011: "Graphical, oral & written",
  //       //   },
  //       // ],
  //       // the courses array should include only the course codes [1010, 1015, 1011]
  //       courses: program.courses?.map((course) => course.code) || [],
  //       // ["EGR1010", "EGR1015", "EGR1011"],
  //       // each PLO object should include the PLO's id code, name , target (expected level of attainment), the results of its evaluation
  //       PLOs: program.peosplos_mapping_details?.map((plo) => {
  //         let PLOObj = {
  //           id: plo.id,
  //           code: plo.code,
  //           name: plo.name,
  //           target: plo.target,
  //           score: plo.score,
  //           evaluationTable: plo.plo_indicators?.map((ind) => {
  //             return {
  //               id: ind.id,
  //               performanceIndicator: ind.name,
  //               EducationalStrategies: [
  //                 ...new Set(
  //                   ind.weight_clos?.map((clo) => clo.clo.course.code)
  //                 ),
  //               ],
  //               MethodsOfAssessment: [
  //                 ...new Set(
  //                   ind.weight_clos
  //                     ?.map((clo) =>
  //                       clo.clo.planned_assessment_methods?.map(
  //                         (am) => am.assessment_name
  //                       )
  //                     )
  //                     .flat()
  //                 ),
  //               ],
  //               WhereSummativeDataAreCollected: [
  //                 ...new Set(
  //                   ind.weight_clos
  //                     ?.map((clo) =>
  //                       clo.clo.assessment_methods?.map((am) => am.name)
  //                     )
  //                     .flat()
  //                 ),
  //               ],
  //               LengthOfAssessmentCycle: Math.max(
  //                 ...[
  //                   ...new Set(
  //                     ind.weight_clos
  //                       ?.map((clo) =>
  //                         clo.clo.planned_assessment_methods?.map(
  //                           (am) => am.length_assessment_cycle
  //                         )
  //                       )
  //                       .flat()
  //                   ),
  //                 ]
  //               ),
  //               YearSemesterOfDataCollection: "2018, 2021",
  //               TargetForPerformance: ind.target,
  //             };
  //           }),
  //           barChart: [
  //             {
  //               name: "Problem statement shows understanding of the problem",
  //               target: 90,
  //               2015: 80,
  //               2018: 85,
  //               2021: 90,
  //             },
  //             {
  //               name: "Problem solution is appropriate and within reasonable constraints",
  //               target: 90,
  //               2015: 80,
  //               2018: 85,
  //               2021: 90,
  //             },
  //           ],
  //           evaluationResults: `For summative assessment (end of program), the decision was made to
  //             focus on the direct assessment for all indicators. Summative data
  //             for Indicators #1 were collected in the Engineering Design I course
  //             (EGR 4090) where students are asked to develop their statement of
  //             the problem and project planning documentation. For Indicator #2 the
  //             assessment was completed in the second semester design course (EGR
  //             4092) as a part of the final assessment of the course. For Indicator
  //             #3 faculty created an examination administered in EGR 3030 which
  //             required students to apply mathematical principles to model
  //             equations to achieve solutions. For Indicator #4 the assessment was
  //             completed in the second semester design course (EGR 4092) as a part
  //             of the final assessment of student performance on the senior project
  //             report using a rubric for the indicator.`,
  //         };
  //         return PLOObj;
  //       }),
  //       // PLOs: [
  //       //   {
  //       //     id: "3.1",
  //       //     code: "3.1",
  //       //     name: "1.  an ability to identify, formulate, and solve complex engineering problems by applying principles of engineering, science, and mathematics",
  //       //     target: "85%",

  //       //     // Results for each PLO evaluation are reported separately in tables.
  //       //     // Each PLO table includes performance indicators, courses and/or co-curricular activities (educational strategies) that provide students an opportunity to demonstrate the indicator, where summative data are collected, timetable, method of assessment and the performance target.
  //       //     // for each PLO table get the following information in the following format:
  //       //     evaluationTable: [
  //       //       {
  //       //         // the following is the performance indicator id:
  //       //         id: "3.1.1",
  //       //         performanceIndicator:
  //       //           "Problem statement shows understanding of the problem",
  //       //         EducationalStrategies: [
  //       //           "EGR 1010",
  //       //           "EGR 1015",
  //       //           "EGR 1011",
  //       //           "EGR 4090",
  //       //         ], //courses
  //       //         MethodsOfAssessment: [
  //       //           "Faculty assessment of design problem statement",
  //       //           "Senior Survey",
  //       //         ],
  //       //         // I am not sure about what it is meant by the following field:
  //       //         WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
  //       //         LengthOfAssessmentCycle: "3 years",
  //       //         YearSemesterOfDataCollection: "2018, 2021",
  //       //         TargetForPerformance: "85%",
  //       //       },
  //       //       {
  //       //         // the following is the performance indicator id:
  //       //         id: "3.1.2",
  //       //         performanceIndicator:
  //       //           "Problem solution is appropriate and within reasonable constraints",
  //       //         EducationalStrategies: [
  //       //           "EGR 1010",
  //       //           "EGR 1015",
  //       //           "EGR 1011",
  //       //           "EGR 4090",
  //       //         ], //courses
  //       //         MethodsOfAssessment: [
  //       //           "Faculty assessment of design problem statement",
  //       //           "Senior Survey",
  //       //         ],
  //       //         // I am not sure about what it is meant by the following field:
  //       //         WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
  //       //         LengthOfAssessmentCycle: "3 years",
  //       //         YearSemesterOfDataCollection: "2018, 2021",
  //       //         TargetForPerformance: "85%",
  //       //       },
  //       //     ],
  //       //     barChart: [
  //       //       {
  //       //         name: "Problem statement shows understanding of the problem",
  //       //         target: 90,
  //       //         2015: 80,
  //       //         2018: 85,
  //       //         2021: 90,
  //       //       },
  //       //       {
  //       //         name: "Problem solution is appropriate and within reasonable constraints",
  //       //         target: 90,
  //       //         2015: 80,
  //       //         2018: 85,
  //       //         2021: 90,
  //       //       },
  //       //     ],
  //       //     evaluationResults: `For summative assessment (end of program), the decision was made to
  //       //       focus on the direct assessment for all indicators. Summative data
  //       //       for Indicators #1 were collected in the Engineering Design I course
  //       //       (EGR 4090) where students are asked to develop their statement of
  //       //       the problem and project planning documentation. For Indicator #2 the
  //       //       assessment was completed in the second semester design course (EGR
  //       //       4092) as a part of the final assessment of the course. For Indicator
  //       //       #3 faculty created an examination administered in EGR 3030 which
  //       //       required students to apply mathematical principles to model
  //       //       equations to achieve solutions. For Indicator #4 the assessment was
  //       //       completed in the second semester design course (EGR 4092) as a part
  //       //       of the final assessment of student performance on the senior project
  //       //       report using a rubric for the indicator.`,
  //       //   },
  //       //   {
  //       //     id: "3.2",
  //       //     code: "3.2",
  //       //     name: "2.   an ability to apply engineering design to produce solutions that meet specified needs with consideration of public health, safety, and welfare, as well as global, cultural, social, environmental, and economic factors",
  //       //     target: "85%",

  //       //     // Results for each PLO evaluation are reported separately in tables.
  //       //     // Each PLO table includes performance indicators, courses and/or co-curricular activities (educational strategies) that provide students an opportunity to demonstrate the indicator, where summative data are collected, timetable, method of assessment and the performance target.
  //       //     // for each PLO table get the following information in the following format:
  //       //     evaluationTable: [
  //       //       {
  //       //         // the following is the performance indicator id:
  //       //         id: "3.2.1",
  //       //         performanceIndicator:
  //       //           "Produces a clear and unambiguous needs statement in a design project",
  //       //         EducationalStrategies: [
  //       //           "EGR 1010",
  //       //           "EGR 1015",
  //       //           "EGR 1011",
  //       //           "EGR 4090",
  //       //         ], //courses
  //       //         MethodsOfAssessment: [
  //       //           "Faculty assessment of design problem statement",
  //       //           "Senior Survey",
  //       //         ],
  //       //         // I am not sure about what it is meant by the following field:
  //       //         WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
  //       //         LengthOfAssessmentCycle: "3 years",
  //       //         YearSemesterOfDataCollection: "2018, 2021",
  //       //         TargetForPerformance: "85%",
  //       //       },
  //       //       {
  //       //         // the following is the performance indicator id:
  //       //         id: "3.2.2",
  //       //         performanceIndicator:
  //       //           "Identifies constraints on the design problem, and establishes criteria for acceptability and desirability of solutions",
  //       //         EducationalStrategies: [
  //       //           "EGR 1010",
  //       //           "EGR 1015",
  //       //           "EGR 1011",
  //       //           "EGR 4090",
  //       //         ], //courses
  //       //         MethodsOfAssessment: [
  //       //           "Faculty assessment of design problem statement",
  //       //           "Senior Survey",
  //       //         ],
  //       //         // I am not sure about what it is meant by the following field:
  //       //         WhereSummativeDataAreCollected: ["EGR 4090", "On-line survey"],
  //       //         LengthOfAssessmentCycle: "3 years",
  //       //         YearSemesterOfDataCollection: "2018, 2021",
  //       //         TargetForPerformance: "85%",
  //       //       },
  //       //     ],
  //       //     barChart: [
  //       //       {
  //       //         name: "Produces a clear and unambiguous needs statement in a design project",
  //       //         2015: 80,
  //       //         2018: 85,
  //       //         2021: 90,
  //       //       },
  //       //       {
  //       //         name: "Identifies constraints on the design problem, and establishes criteria for acceptability and desirability of solutions",
  //       //         2015: 80,
  //       //         2018: 85,
  //       //         2021: 90,
  //       //       },
  //       //     ],
  //       //     evaluationResults: `For the summative assessment (end of program), the decision was made to focus on the faculty’s direct assessment for all indicators.  Summative data for Indicators #1 and #2 were collected in the Engineering Design I (EGR4090) course. For Indicator #3 and Indicator #4 data were taken in the second semester design sequence (EGR4092) where the design project was completed. The scoring rubrics to assess student performance in both courses were completed by the faculty. The percent of the students that demonstrated each criterion were as follows:  Indicator #1 - 82%; Indicator #2 - 88% and Indicator #3-90%; and Indicator #4-89%.`,
  //       //   },
  //       // ],
  //       description: `<p>The assessment of student outcomes is done on a three-year cycle, and thus twice within an ABET cycle. </p>`,
  //     },

  //     ContinuousImprovement: {
  //       description: `<p>This information is included in each outcome table. </p>`,
  //     },
  //     AdditionalInformation: {
  //       description: `<p>There will be a student outcomes notebook in the ABET resource room which will contain all assessment instruments and rubrics if they were used to assess the outcome.</p>`,
  //     },
  //   };

  //   return CRITERION4_CONTINUOUSIMPROVEMENT;
  // };

  // const deriveCriterion5 = (program) => {
  //   const CRITERION5_CURRICULUM = {
  //     ProgramCurriculum: {
  //       //If there is more than one curricular path or option for a program, a separate programCurriculumTable should be provided for each path or option.
  //       programCurriculumTable: program.courses?.map((course) => {
  //         let courseTitle = `${course.department_details?.[0]?.name} ${course.code} - ${course.title} `;
  //         let courseObj = {
  //           id: course.id,
  //           title: courseTitle,
  //           // courseCode: "2015",
  //           // courseTitle: "Computing Tools of Engineers",
  //           // departmentName: "EGR",
  //           prerequisites: course.prerequisites_ids,
  //           corequisites: course.co_requisites_ids,
  //           mathBasicSciencesCredits: "10",
  //           engineeringTopicsCredits: "3",
  //           otherCredits: "5",
  //           credits: "14",
  //           type:
  //             course.category === "Required"
  //               ? "R"
  //               : course.category === "Elective"
  //               ? "E"
  //               : "SE",
  //           courseLastTwoTerms: ["Fall 2024", "Fall 2025"],
  //           maximumSectionEnrollment: "...",
  //           yearTerm: "Freshman/fall",
  //         };
  //         return courseObj;
  //       }),

  //       // programCurriculumTable: [
  //       //   {
  //       //     id: "1",
  //       //     title: "EGR 2015 Computing Tools of Engineers",
  //       //     // courseCode: "2015",
  //       //     // courseTitle: "Computing Tools of Engineers",
  //       //     // departmentName: "EGR",
  //       //     prerequisites: "None",
  //       //     corequisites: "None",
  //       //     mathBasicSciencesCredits: "10",
  //       //     engineeringTopicsCredits: "3",
  //       //     otherCredits: "5",
  //       //     credits: "14",
  //       //     type: "SE",
  //       //     courseLastTwoTerms: ["Fall 2024", "Fall 2025"],
  //       //     maximumSectionEnrollment: 100,
  //       //     yearTerm: "Freshman/fall",
  //       //   },
  //       //   {
  //       //     id: "2",
  //       //     title: "MTH 3030 Applied Math",
  //       //     prerequisites: "None",
  //       //     corequisites: "None",
  //       //     mathBasicSciencesCredits: "10",
  //       //     engineeringTopicsCredits: "3",
  //       //     otherCredits: "5",
  //       //     credits: "14",
  //       //     type: "SE",
  //       //     courseLastTwoTerms: ["Fall 2024", "Fall 2025"],
  //       //     maximumSectionEnrollment: 100,
  //       //     yearTerm: "Freshman/fall",
  //       //   },
  //       // ],
  //       description: `<p>The curriculum for the Engineering program at Upper State University has been designed by the faculty to produce a graduate broadly acquainted with tools and principles that would be used in the engineering field.  While designed to develop the essential knowledge, skills, and abilities needed for professional practice or graduate study, the curricular structure of the program, coupled with the integrated influence of liberal arts studies, equips our students with a holistic educational experience that is designed to prepare students to succeed in a world characterized by rapidly developing technology, growing complexity, and globalization. The curriculum aligns with the program educational objectives through its direct support of the student outcomes.  Student outcomes map directly into program educational objectives.</p>
  //       <br></br><p>The Upper State University Engineering curriculum builds from basic to advanced courses, has a logical prerequisite tree, and balances semester loads among various technical and general education courses. All students take a common engineering core and then “invest” their elective engineering courses in one of four options, civil, chemical, electrical, or mechanical engineering.</p>`,
  //     },
  //     CourseSyllabi: {},
  //     Analysis: {},
  //   };
  //   return CRITERION5_CURRICULUM;
  // };

  // const deriveCriterion6 = (program) => {
  //   const CRITERION6_FACULTY = {
  //     FacultyQualifications: {
  //       description: `<p>Faculty members come from a wide variety of backgrounds and bring experience from education, research, and industry. Several faculty members are currently consultants with industry. All but the adjunct faculty hold earned Ph.D. degrees. Eight of the faculty members have significant industrial experience, and nine are active with sponsored research programs. All faculty members are members of at least one professional society related to engineering. Drs. Young and Zanzibar are the most recent hires (Fall, 2018). They will be participating in the National Effectiveness in Teaching Institute (NETI) workshop in the coming year. All faculty members with civil engineering backgrounds are registered professional engineers, as are four other faculty members.
  //       </p><br></br><p>Given the university’s emphasis on serving the world-wide community, the diversity of the faculty is a strength of our program.  Faculty members represent several different countries and nationalities, thus strengthening the global perspective of the program.  All Engineering faculty members possess excellent oral and written communication skills. These attributes are considered in the hiring process.</p>`,
  //       FacultyQualificationsTable: program.courses
  //         ?.map((course) => {
  //           return course?.instructors?.map((instructor) => {
  //             let registrations = instructor.registrations?.map(
  //               (registration) =>
  //                 `${registration.code} (${registration.organization})`
  //             );
  //             let certificationtions = instructor.registrations?.map(
  //               (registration) =>
  //                 `${registration.code} ${registration.issued_by}`
  //             );
  //             let registrationsAndCertifications =
  //               registrations?.concat(certificationtions)?.join(", ") || "None";

  //             let academiaExperienceYears =
  //               instructor.teaching_and_academic_experience
  //                 ?.map((exp) => {
  //                   return calculateYearsBetweenExperienceDates(
  //                     exp.start_date,
  //                     exp.end_date,
  //                     exp.until_now
  //                   );
  //                 })
  //                 .reduce((sum, years) => sum + years, 0) || 0;

  //             let nonAcademiaExperienceYears =
  //               instructor.professionalExperience
  //                 ?.map((exp) => {
  //                   return calculateYearsBetweenExperienceDates(
  //                     exp.start_date,
  //                     exp.end_date,
  //                     exp.until_now
  //                   );
  //                 })
  //                 .reduce((sum, years) => sum + years, 0) || 0;

  //             let insideInstitutionExperience =
  //               instructor.teaching_and_academic_experience.find(
  //                 (exp) =>
  //                   exp.until_now &&
  //                   exp.institution == program.university_detail?.[0]?.name
  //               );
  //             console.log(
  //               "insideInstitutionExperience",
  //               insideInstitutionExperience
  //             );

  //             let instructorObj = {
  //               id: instructor.id,
  //               name: `${instructor.first_name} ${instructor.last_name}`,
  //               degree: `${instructor.diploma} ${instructor.diploma_date}`,
  //               rank: instructor.rank,
  //               AcademicAppointmentType:
  //                 instructor.type_of_academic_appointment,
  //               employmentStatus: instructor.full_time ? "FT" : "PT",
  //               nonAcademiaExperienceYears: nonAcademiaExperienceYears,
  //               academiaExperienceYears: academiaExperienceYears,
  //               insideInstitutionExperienceYears:
  //                 calculateYearsBetweenExperienceDates(
  //                   insideInstitutionExperience?.start_date,
  //                   insideInstitutionExperience?.end_date,
  //                   true
  //                 ),

  //               ProfessionalRegistrationCertification:
  //                 registrationsAndCertifications,

  //               ProfessionalOrganizationsActivityLevel: "...",
  //               ProfessionalDevelopmentActivityLevel: "...",
  //               industryConsultingORSummerWorkActivityLevel: "...",
  //             };
  //             return instructorObj;
  //           });
  //         })
  //         .flat(),

  //       // [
  //       //   {
  //       //     id: "1",
  //       //     name: "Dr. John Doe",
  //       //     degree: "Ph.D. (2003)",
  //       //     rank: "AST",
  //       //     AcademicAppointmentType: "TT",
  //       //     employmentStatus: "FT",
  //       //     nonAcademiaExperienceYears: "1",
  //       //     academiaExperienceYears: "11",
  //       //     insideInstitutionExperienceYears: "2",
  //       //     ProfessionalRegistrationCertification: "PE (VA)",
  //       //     ProfessionalOrganizationsActivityLevel: "H",
  //       //     ProfessionalDevelopmentActivityLevel: "M",
  //       //     industryConsultingORSummerWorkActivityLevel: "L",
  //       //   },

  //       // ],
  //     },
  //     FacultyWorkload: {
  //       FacultyWorkloadTable: program.courses
  //         ?.map((course) => {
  //           return course?.instructors?.map((instructor) => {
  //             let instructorObj = {
  //               id: instructor.id,
  //               name: `${instructor.first_name} ${instructor.last_name}`,
  //               employmentStatus: instructor.full_time ? "FT" : "PT",
  //               // classes For the academic year for which the self-study is being prepared.
  //               classes: instructor.courses_taught?.map(
  //                 (course) =>
  //                   `${course.course__code} (${course.course__credit_hours}) ${course.course__semester__name}/ ${course.course__semester__academicYear__name}`
  //               ),
  //               // [
  //               //   "EGR 3050 (3) SP/19",
  //               //   "EGR 3030 (3) F/19 & SP/20",
  //               //   "EGR 3020 (3) SP/19 & SP/20",
  //               // ],
  //               teachingActivitiesPercentage: "...%",
  //               researchOrScholarshipActivitiesPercentage: "...%",
  //               otherActivitiesPercentage: "...%",
  //               timePercentageDevotedToTheProgram: "...%",
  //             };
  //             return instructorObj;
  //           });
  //         })
  //         .flat(),
  //       // [
  //       //   {
  //       //     id: "1",
  //       //     name: "Dr. John Doe",
  //       //     employmentStatus: "FT",
  //       //     // classes For the academic year for which the self-study is being prepared.
  //       //     classes: [
  //       //       "EGR 3050 (3) SP/19",
  //       //       "EGR 3030 (3) F/19 & SP/20",
  //       //       "EGR 3020 (3) SP/19 & SP/20",
  //       //     ],
  //       //     teachingActivitiesPercentage: "60%",
  //       //     researchOrScholarshipActivitiesPercentage: "10%",
  //       //     otherActivitiesPercentage: "30%",
  //       //     timePercentageDevotedToTheProgram: "100%",
  //       //   },
  //       //   {
  //       //     id: "2",
  //       //     name: "Dr. Robert Armstrong",
  //       //     employmentStatus: "FT",
  //       //     classes: [
  //       //       "EGR 3050 (3) SP/19",
  //       //       "EGR 3030 (3) F/19 & SP/20",
  //       //       "EGR 3020 (3) SP/19 & SP/20",
  //       //     ],
  //       //     teachingActivitiesPercentage: "60%",
  //       //     researchOrScholarshipActivitiesPercentage: "10%",
  //       //     otherActivitiesPercentage: "30%",
  //       //     timePercentageDevotedToTheProgram: "100%",
  //       //   },
  //       // ]
  //       description: `<p>The normal teaching load is two courses per semester. The program chairperson teaches one course per semester.</p>`,
  //     },
  //     FacultySize: {
  //       description: `<p>Since the last ABET visit, the number of faculty members in Engineering has grown. Eight new faculty members all with full-time appointments in Engineering have been hired. The Engineering faculty is sufficient to cover all of the required EGR courses and each of the elective courses, with at least two faculty members capable of teaching each course.</p><p><br></p><table style="width: initial;"><tbody><tr><td style="width: 204px;"><p data-cellwidth="204px">Faculty Member</p><p data-cellwidth="204px"><br></p></td><td style="width: 204px;"><p data-cellwidth="204px">Competency Area</p><p data-cellwidth="204px"><br></p></td></tr><tr><td style="width: 204px;"><p data-cellwidth="204px">Begone</p></td><td style="width: 204px;"><p data-cellwidth="204px">Civil</p></td></tr><tr><td style="width: 204px;"><p data-cellwidth="204px">Aloevera*</p></td><td style="width: 204px;"><p data-cellwidth="204px">Mechanical</p></td></tr><tr><td style="width: 204px;"><p data-cellwidth="204px">Activeeti</p></td><td style="width: 204px;"><p data-cellwidth="204px">Chemical</p></td></tr></tbody></table><p><br></p><p>Ten adjunct faculty members from local industry are available to help with teaching responsibilities. All of the core courses are offered at least once a year, and all of the elective courses are offered once a year. Some of the EGR courses are offered in the summer to accommodate cooperative education and internship students.</p><p><br></p><p><strong><u>Interactions with Students, Student Advising and Counseling.</u></strong> As described in Criterion 1, full- time academic advisors conduct the majority of student advising. However, faculty interact closely with students in career decisions and advising, they direct independent research students, and employ NSF Undergraduate Research, minority and other undergraduate research students in their laboratories. Program faculty members also advise very active student chapters of the professional societies (ASCE, ASME, AIChE, IEEE). All faculty members maintain an open-door policy for student office hours and consultation.</p><p><br></p><p><strong><u>University Service.</u></strong> Program service activities are extensive. Our faculty members lead or participate in twelve college or university committees. A significant number of our faculty members are also involved in outreach programs to the local schools and communities. They participate through Upper State University sponsored activities (summer institutes, math and science camps, open house, job-shadowing activities, etc.) and through their own initiatives (math/science conferences for elementary school girls, other outreach programs in K-12 classrooms, science fair sponsorships).</p><p><br></p><p><strong><u>Professional Development.</u></strong> In addition to sponsored research and industrial consulting, our faculty members are active in professional society activities. Five are very active in ABET, serving as program evaluators or commissioners. Several lead divisions of their professional societies. Program faculty members chair two NIST committees.</p><p><br></p><p><strong><u>Interaction with Industry.</u></strong> Some of our faculty members consult for industry and are actively involved in proposal reviews and panels. Industrial representatives are frequently invited as guest lecturers in many of the undergraduate classes.</p><p><br></p>`,
  //     },
  //     ProfessionalDevelopment: {
  //       description: `<p>All Engineering faculty members are expected to maintain currency in their discipline through scholarly and professional development activities. Engineering faculty participate in a wide range of professional societies including ASCE, ASME, AIChE, IEEE, ASEE, and others. International study opportunities for undergraduate students have been provided by our faculty who have developed or facilitated exchange programs in Italy, England, Mexico, Australia, and Puerto Rico. All of our faculty members have participated in the workshops conducted by our Teaching &amp; Learning Center (TLC); some have even conducted these workshops. Others participate regularly in special workshops and conferences sponsored by such organizations as ASEE, NSF, ABET, and others. See the faculty resumes in Appendix B for more information on individual faculty members.</p><p><br></p><p>Since professional development is required for faculty tenure and promotion decisions, faculty members are assisted and encouraged in these activities with an annual, individual professional development fund. The amount has varied over the past six years but has generally fallen between $1500 and $2000 annually. The funding is provided by the university. In addition, many faculty members have funded research programs, in which they involve undergraduate researchers. See the faculty resumes in Appendix B for the professional development activities for each faculty member.</p><p><br></p><p>Faculty evaluations are based on how each faculty member supports the educational mission of the program, the college, and the university. As required by the Upper State University Faculty Handbook, evaluations are conducted annually in the following ways:</p><p><br></p><p><strong><u>Teaching Portfolio:</u></strong> Each faculty member assembles a teaching portfolio that includes examples of student work, records of assessment, and retrospective analysis of means of improvement. Student evaluations are also included in the record as are, when appropriate, special awards and student letters.</p><p><br></p><p><strong><u>Review of teaching by The Teaching and Learning Center:</u></strong> Each faculty member is required to conduct a conference with a TLC consultant every three years. The consultant conducts a direct classroom observation and then discusses his/her observations with the faculty member. If suggestions for improvement are made, the teaching portfolio includes this information and the tracking of how attempts at improvement were made.</p><p><br></p><p><strong><u>Annual Review:</u></strong> Each faculty member completes an annual report on all university activities— teaching, research, and service. The format is prescribed, and the teaching portfolio is also included in this package. The chairperson discusses the annual report with each faculty member and uses the review to make decisions on merit-pay changes.</p><p><br></p>`,
  //     },
  //     AuthorityAndResponsibilityOfFaculty: {
  //       description: `<p>All program changes originate in the Engineering Curriculum Committee. The program faculty approves changes and forwards them to the College Curriculum Committee. All changes must originate in the program. The program faculty is responsible for evaluating the program. Some assistance is obtained from the Office of Instructional Technology to maintain our web-based surveys. All EGR courses are taught by full-time faculty members in the program.</p>`,
  //     },
  //   };
  //   return CRITERION6_FACULTY;
  // };

  // const deriveCriterion7 = (program) => {
  //   const CRITERION7_FACILITIES = {};
  //   return CRITERION7_FACILITIES;
  // };

  // const deriveCriterion8 = (program) => {
  //   const CRITERION8_INSTITUTIONALSUPPORT = {};
  //   return CRITERION8_INSTITUTIONALSUPPORT;
  // };

  useEffect(() => {
    dispatch(fetchReport(id))
      .unwrap()
      .then((report) => {
        setReportBody(JSON.parse(report.report_body));
        console.log("reportBody:", JSON.parse(report.report_body));
        // setDerivedBackgroundInformation(
        //   JSON.parse(report.report_body).BACKGROUNDINFORMATION
        // );
        // setDerivedCriterion1(JSON.parse(report.report_body).CRITERION1_STUDENTS);
        // setDerivedCriterion2(JSON.parse(report.report_body).CRITERION2_PROGRAMEDUCATIONALOBJECTIVES);
        // setDerivedCriterion3(JSON.parse(report.report_body).CRITERION3_STUDENTOUTCOMES);
        // setDerivedCriterion4(JSON.parse(report.report_body).CRITERION4_CONTINUOUSIMPROVEMENT);
        // setDerivedCriterion5(JSON.parse(report.report_body).CRITERION5_CURRICULUM);
        // setDerivedCriterion6(JSON.parse(report.report_body).CRITERION6_FACULTY);
        // setDerivedCriterion7(JSON.parse(report.report_body).CRITERION7_FACILITIES);
        // setDerivedCriterion8(JSON.parse(report.report_body).CRITERION8_INSTITUTIONALSUPPORT);
        dispatch(fetchProgramById(report.resource_id))
          .unwrap()
          .then((originalPromiseResult) => {
            // setDerivedBackgroundInformation(
            //   deriveBackgroundInformation(originalPromiseResult)
            // );
            // setDerivedCriterion1(deriveCriterion1(originalPromiseResult));
            // setDerivedCriterion2(deriveCriterion2(originalPromiseResult));
            // setDerivedCriterion3(deriveCriterion3(originalPromiseResult));
            // setDerivedCriterion4(deriveCriterion4(originalPromiseResult));
            // setDerivedCriterion5(deriveCriterion5(originalPromiseResult));
            // setDerivedCriterion6(deriveCriterion6(originalPromiseResult));
            // setDerivedCriterion7(deriveCriterion7(originalPromiseResult));
            // setDerivedCriterion8(deriveCriterion8(originalPromiseResult));
          })
          .catch((rejectedValueOrSerializedError) => {
            console.log(
              "rejectedValueOrSerializedError:",
              rejectedValueOrSerializedError
            );
          });
      })
      .catch((rejectedValueOrSerializedError) => {
        console.log(
          "rejectedValueOrSerializedError:",
          rejectedValueOrSerializedError
        );
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setExpandDocumentsSection(true);
      } else {
        setExpandDocumentsSection(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const program = useSelector((state) => state.program.program);
  const report = useSelector((state) => state.AnnualProgramReport.Report);

  // const handleSaveClick = () => {
  //   // Add your edit logic here
  //   console.log("Edit button clicked");
  // };

  const handleSaveClick = async () => {
    const updatedReportBody = JSON.stringify(reportBody);

    const resultAction = await dispatch(
      updateReport({
        id,
        data: {
          report_body: updatedReportBody,
          body: "ABET",
          type: "Self Study Report",
          resource: "program",
          resource_id: report.resource_id,
          assign_to: report.assign_to,
        },
      })
    );
    if (updateReport.fulfilled.match(resultAction)) {
      // user will have a type signature of User as we passed that as the Returned parameter in createAsyncThunk
      openNotificationWithIcon("success", `Updated successfully`);
      dispatch(fetchReport(id)).unwrap();
    } else {
      if (resultAction.payload) {
        // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, those types will be available here.
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
      } else {
        setHandledError(resultAction.error);
        handleOpenErrorModal();
      }
    }
  };

  console.log("report in SSR.js", reportBody);

  return (
    <>
      <Stepper
        stateName={stateName}
        setStateName={setStateName}
        states={possibleStates}
      />
      <GridContainer style={containerStyle}>
        <GridItem
          xs={12}
          sm={expandDocumentsSection ? 8 : 11}
          md={expandDocumentsSection ? 8 : 11}
          lg={expandDocumentsSection ? 9 : 11}
          style={transitionStyle}
        >
          <Card withPadding style={{ height: "100%" }}>
            <Report
              program={program}
              report={reportBody}
              setReportBody={setReportBody}
              derivedBackgroundInformation={reportBody?.BACKGROUNDINFORMATION}
              derivedCriterion1={reportBody?.CRITERION1_STUDENTS}
              derivedCriterion2={
                reportBody?.CRITERION2_PROGRAMEDUCATIONALOBJECTIVES
              }
              derivedCriterion3={reportBody?.CRITERION3_STUDENTOUTCOMES}
              derivedCriterion4={reportBody?.CRITERION4_CONTINUOUSIMPROVEMENT}
              derivedCriterion5={reportBody?.CRITERION5_CURRICULUM}
              derivedCriterion6={reportBody?.CRITERION6_FACULTY}
              derivedCriterion7={reportBody?.CRITERION7_FACILITIES}
              derivedCriterion8={reportBody?.CRITERION8_INSTITUTIONALSUPPORT}
            />
          </Card>
        </GridItem>
        <GridItem
          xs={12}
          sm={expandDocumentsSection ? 4 : 1}
          md={expandDocumentsSection ? 4 : 1}
          lg={expandDocumentsSection ? 3 : 1}
          style={transitionStyle}
        >
          <Card withPadding style={{ height: "100%" }}>
            <ReportDocumentsSection
              reportId={id}
              currentUser={currentUser}
              expandDocumentsSection={expandDocumentsSection}
              setExpandDocumentsSection={setExpandDocumentsSection}
            />
          </Card>
        </GridItem>
      </GridContainer>
      <FloatingEditButton onClick={handleSaveClick} />
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </>
  );
};
export default SSR;
